import { AdBannerImage, AdBannerRoot } from "./AdBanner.styles";
import { AdBannerProps } from "./AdBanner.types";

export default function AdBanner({ src, alt, linkTo }: AdBannerProps) {
    function onAdBannerClick() {
        if (linkTo) {
            window.open(linkTo, "_blank");
        }
    }

    return (
        <AdBannerRoot onClick={() => onAdBannerClick()}>
            <AdBannerImage src={src} alt={alt} />
        </AdBannerRoot>
    );
}
